var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ctrl-login"},[_c('div',{staticClass:"wrap"},[_c('CtrlProductRegisterProduct',{attrs:{"categoryId":_vm.categoryId,"productId":_vm.productId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }